
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface Dashboardcontexttype {
  showDashboard: boolean;
  toggleDashboard: () => void;
  setShowDashboard: (show: boolean) => void;
}

const Dashboardcontext = createContext<Dashboardcontexttype | undefined>(undefined);

export const useDashboard = () => {
  const context = useContext(Dashboardcontext);
  if (!context) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
};

interface Dashboardproviderprops {
  children: ReactNode;
}

export const Dashboardprovider: React.FC<Dashboardproviderprops> = ({ children }) => {
  const [showDashboard, setShowDashboard] = useState<boolean>(() => {
    const saved = localStorage.getItem('dashboardVisible');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const toggleDashboard = () => {
    const newValue = !showDashboard;
    setShowDashboard(newValue);
    localStorage.setItem('dashboardVisible', JSON.stringify(newValue));
  };

  const setDashboardValue = (show: boolean) => {
    setShowDashboard(show);
    localStorage.setItem('dashboardVisible', JSON.stringify(show));
  };

  return (
    <Dashboardcontext.Provider 
      value={{ 
        showDashboard, 
        toggleDashboard, 
        setShowDashboard: setDashboardValue 
      }}
    >
      {children}
    </Dashboardcontext.Provider>
  );
};
